<template>
    <div class="miniProduct">
        <div class="row">
            <div class="col-4">
                <img v-if="mainImage" :data-src="mainImage" :alt="title" class="lazyload img-fluid">
            </div>
            <div class="col-8">
                <strong><span v-if="referenceTitle">{{ referenceTitle }} - </span>{{ title }}</strong>
                <span v-if="'site.repository.product_reference' === type || 'site.repository.fidelity_gift' === type">Quantité : {{ quantity }}</span>
                <span v-if="'site.repository.product_reference' === type" class="prix">{{ total | moneyFormat }} <del v-if="unitsTotal != total">{{ unitsTotal | moneyFormat }}</del></span>
                <span v-if="'site.repository.fidelity_gift' === type" class="prix">{{ total }} points fidélité</span>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState, mapActions, mapGetters} from 'vuex';

    import store from '../store';

    const CartWidgetItem = {
        name: 'ponroy-cart-widget-item',
        store,
        props: {
            type: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            referenceTitle: {
                type: String,
            },
            unitsTotal: {
                type: Number,
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
            quantity: {
                type: Number,
                required: true,
            },
            mainImage: {
                type: String,
            },
        },
        computed: {
        },
        methods: {
        }
    };

    export default CartWidgetItem;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartWidgetItem.vue